import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import config from "./config";
import MaintenanceBoard from "./components/common/MaintenanceBoard";
import "../src/assets/styles/kig.css";

const container = document.getElementById("root");
const root = createRoot(container);
const maintenanceEnabled = config.maintenance?.enabled === true;

root.render(
  <React.StrictMode>
    {maintenanceEnabled ? (
      <MaintenanceBoard />
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);
